export const projectsData = [
  {
    id: 1,
    title: "Complete Home Makeover – Sector 86, Gurugram",
    location: "Sector 86, Gurugram",
    type: "Reconstruction + Interiors + Bespoke Furniture",
    category: "Complete Home",
    image: "https://images.pexels.com/photos/1571460/pexels-photo-1571460.jpeg",
    description: "Complete reconstruction of an independent house with modern interior design and custom furniture.",
    clientBrief: "The clients needed a full reconstruction and modern redesign of their traditional home, seeking a contemporary aesthetic with warm, inviting spaces.",
    solution: "We reconfigured the entire layout, created an open-plan living area, designed custom storage solutions, and used a warm palette of woods and neutrals.",
    images: [
      "https://images.pexels.com/photos/1571460/pexels-photo-1571460.jpeg",
      "https://images.pexels.com/photos/1090638/pexels-photo-1090638.jpeg",
      "https://images.pexels.com/photos/2724749/pexels-photo-2724749.jpeg",
      "https://images.pexels.com/photos/11701120/pexels-photo-11701120.jpeg"
    ]
  },
  {
    id: 2,
    title: "Modern Bedroom Suite – Gurugram",
    location: "Gurugram",
    type: "Interior Design + Bespoke Furniture",
    category: "Bedroom",
    image: "https://images.pexels.com/photos/35189674/pexels-photo-35189674.jpeg",
    description: "Luxurious bedroom design with custom wood paneling and integrated wardrobe solutions.",
    clientBrief: "Create a serene, hotel-like bedroom retreat with ample storage and sophisticated aesthetics.",
    solution: "Designed custom wood paneling as a feature wall, integrated wardrobe systems, and used layered lighting for ambiance.",
    images: [
      "https://images.pexels.com/photos/35189674/pexels-photo-35189674.jpeg",
      "https://images.pexels.com/photos/3315286/pexels-photo-3315286.jpeg",
      "https://images.pexels.com/photos/11701120/pexels-photo-11701120.jpeg"
    ]
  },
  {
    id: 3,
    title: "Contemporary Kitchen Redesign",
    location: "Sector 86, Gurugram",
    type: "Interior Design + Custom Cabinetry",
    category: "Kitchen",
    image: "https://images.pexels.com/photos/2724749/pexels-photo-2724749.jpeg",
    description: "Modern kitchen with clean lines, marble countertops, and custom storage solutions.",
    clientBrief: "Transform a cramped, dated kitchen into a bright, functional cooking space with modern aesthetics.",
    solution: "Opened up the layout, installed custom white cabinetry with soft-close mechanisms, and added a central island for prep and dining.",
    images: [
      "https://images.pexels.com/photos/2724749/pexels-photo-2724749.jpeg",
      "https://images.pexels.com/photos/1080721/pexels-photo-1080721.jpeg"
    ]
  },
  {
    id: 4,
    title: "Elegant Dining Space",
    location: "Gurugram",
    type: "Interior Design + Custom Furniture",
    category: "Dining",
    image: "https://images.unsplash.com/photo-1617098709804-705581f844eb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwzfHxkaW5pbmclMjByb29tfGVufDB8fHx8MTc2NzQzMTczNXww&ixlib=rb-4.1.0&q=85",
    description: "Warm dining room with custom table, elegant lighting, and sophisticated material palette.",
    clientBrief: "Design a dining area that's perfect for family meals and entertaining guests.",
    solution: "Custom-designed dining table with rich wood tones, statement lighting, and coordinated soft furnishings.",
    images: [
      "https://images.unsplash.com/photo-1617098709804-705581f844eb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwzfHxkaW5pbmclMjByb29tfGVufDB8fHx8MTc2NzQzMTczNXww&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1616486886892-ff366aa67ba4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxkaW5pbmclMjByb29tfGVufDB8fHx8MTc2NzQzMTczNXww&ixlib=rb-4.1.0&q=85"
    ]
  },
  {
    id: 5,
    title: "Modern Home Office",
    location: "Gurugram",
    type: "Interior Design + Storage Solutions",
    category: "Office",
    image: "https://images.pexels.com/photos/12379606/pexels-photo-12379606.jpeg",
    description: "Functional and stylish home office with custom shelving and ergonomic design.",
    clientBrief: "Create a productive home workspace that doesn't compromise on style.",
    solution: "Designed built-in shelving, integrated desk solutions, and used calming colors for focus.",
    images: [
      "https://images.pexels.com/photos/12379606/pexels-photo-12379606.jpeg",
      "https://images.pexels.com/photos/1090638/pexels-photo-1090638.jpeg"
    ]
  },
  {
    id: 6,
    title: "Luxury Kitchen with Island",
    location: "Sector 86, Gurugram",
    type: "Complete Kitchen Renovation",
    category: "Kitchen",
    image: "https://images.pexels.com/photos/1080721/pexels-photo-1080721.jpeg",
    description: "High-end kitchen with marble finishes, custom cabinetry, and premium appliances.",
    clientBrief: "Design a gourmet kitchen that's both beautiful and highly functional for serious cooking.",
    solution: "Installed premium marble countertops, custom white cabinetry with gold accents, and integrated high-end appliances.",
    images: [
      "https://images.pexels.com/photos/1080721/pexels-photo-1080721.jpeg",
      "https://images.pexels.com/photos/2724749/pexels-photo-2724749.jpeg"
    ]
  }
];

export const servicesData = [
  {
    id: 1,
    title: "Complete Home Makeovers & Reconstruction",
    description: "Transform your existing home into your dream space with our comprehensive reconstruction services.",
    image: "https://images.pexels.com/photos/834892/pexels-photo-834892.jpeg",
    features: [
      "Structural changes and reconfiguration of existing homes",
      "New layouts, planning, and approvals coordination",
      "Integration of utilities, lighting, and finishes",
      "Complete project management from start to finish"
    ]
  },
  {
    id: 2,
    title: "Interior Design & Space Planning",
    description: "Thoughtfully designed interiors that reflect your lifestyle and aesthetic preferences.",
    image: "https://images.pexels.com/photos/5922204/pexels-photo-5922204.jpeg",
    features: [
      "Concept development, moodboards, and space planning",
      "Detailed drawings and 3D visualizations",
      "Material and color selection tailored to client lifestyle",
      "Lighting design and fixture selection"
    ]
  },
  {
    id: 3,
    title: "Bespoke Furniture & Joinery",
    description: "Custom-designed furniture crafted to perfectly fit your space and needs.",
    image: "https://images.pexels.com/photos/11701120/pexels-photo-11701120.jpeg",
    features: [
      "Custom designed furniture for living, dining, bedrooms, and study",
      "Tailor-made storage solutions and wardrobes",
      "Finish options using laminates, veneers, and upholstery",
      "On-site carpentry and installation"
    ]
  },
  {
    id: 4,
    title: "Turnkey Design & Execution",
    description: "End-to-end project delivery with complete peace of mind.",
    image: "https://images.pexels.com/photos/4101143/pexels-photo-4101143.jpeg",
    features: [
      "End-to-end project handling from design to final styling",
      "Contractor coordination, site supervision, and execution quality control",
      "Transparent budgeting and timelines",
      "Regular updates and client communication"
    ]
  },
  {
    id: 5,
    title: "Office Interiors & Turnkey Projects",
    description: "Professional workspace design that enhances productivity and reflects your brand identity.",
    image: "https://images.pexels.com/photos/12379606/pexels-photo-12379606.jpeg",
    features: [
      "Complete office interior design and space planning",
      "Modular furniture and ergonomic workstation design",
      "Brand-aligned aesthetics and color schemes",
      "Turnkey execution with minimal business disruption",
      "Meeting rooms, cabins, and collaborative spaces"
    ]
  }
];

export const reviewsData = [
  {
    id: 1,
    name: "Shruti Gupta",
    rating: 5,
    text: "Mayo Design gave our home a much needed makeover. They handled the complete reconstruction beautifully, with stunning interior designing and bespoke furniture. The entire project was extremely professionally handled from start to finish. Highly recommend!",
    date: "2024"
  },
  {
    id: 2,
    name: "Prashant Kumar",
    rating: 5,
    text: "Exceptional service from Mayo Design. Their responsiveness, professionalism, and value for money are outstanding. They truly understand what clients need and deliver beyond expectations.",
    date: "2024"
  }
];

export const processSteps = [
  {
    id: 1,
    title: "Initial Call & Site Visit",
    description: "We start by understanding your needs, walking through your space, and discussing your budget and timeline.",
    icon: "Phone"
  },
  {
    id: 2,
    title: "Concept & Planning",
    description: "Our team creates layouts, moodboards, and initial concepts tailored to your vision and lifestyle.",
    icon: "Lightbulb"
  },
  {
    id: 3,
    title: "Detailed Design",
    description: "We develop detailed drawings, 3D visualizations, material selections, and obtain necessary approvals.",
    icon: "Layers"
  },
  {
    id: 4,
    title: "Execution & Bespoke Furniture",
    description: "On-site work begins with our expert contractors, while custom furniture is crafted with precision.",
    icon: "Hammer"
  },
  {
    id: 5,
    title: "Styling & Handover",
    description: "Final styling, setup, and a complete walkthrough to ensure everything exceeds your expectations.",
    icon: "CheckCircle"
  }
];

export const faqData = [
  {
    id: 1,
    question: "How does the design process work from first call to handover?",
    answer: "Our process starts with an initial consultation and site visit, followed by concept development, detailed design with 3D visualizations, execution phase with regular updates, and finally styling and handover. The entire journey typically takes 3-6 months depending on project scope."
  },
  {
    id: 2,
    question: "What are typical project timelines?",
    answer: "Timelines vary based on scope: Complete home makeovers typically take 4-6 months, single room renovations 6-10 weeks, and furniture-only projects 4-8 weeks. We provide a detailed timeline during the planning phase."
  },
  {
    id: 3,
    question: "How are design fees and execution costs structured?",
    answer: "We charge a design fee based on project scope, which covers concept development, detailed drawings, and 3D visualizations. Execution costs are transparently broken down for materials, labor, and furniture. We provide detailed quotations before work begins."
  },
  {
    id: 4,
    question: "How do you handle site visits and communication?",
    answer: "We maintain regular communication through phone, WhatsApp, and scheduled site visits. Our team provides weekly updates with photos, and we're always available to address concerns promptly."
  },
  {
    id: 5,
    question: "Do you provide warranties on your work?",
    answer: "Yes, we provide warranties on all our work including carpentry, furniture, and installations. Specific warranty terms are outlined in the project agreement."
  }
];